export default "__VITE_ASSET__DbEvw1_v__"